import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import Typography from '@material-ui/core/Typography';
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import _Classnames from 'classnames';
import { createStructuredSelector } from 'reselect';
import { useSelector } from 'react-redux';
import { makeSelectClientDetails } from 'containers/Main/selectors';

const clientDetailsSelector = createStructuredSelector({
  clientDetails: makeSelectClientDetails(),
});

const useStyles = makeStyles(theme => ({
  item: {
    paddingLeft: 17,
    display: '-webkit-box',
    margin: '0 auto',
    '-webkit-line-clamp': '1',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    [theme.breakpoints.down('xs')]: {
      ...theme.typography.body2,
      lineHeight: 1.7,
    },
    '& > span': {
      ...theme.typography.overline,
      lineHeight: '28px',
    },
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  itemWrapper: {
    height: 34,
  },
  active: {
    background: theme.palette.primary.main,
    color: '#fff',
  },
  ul: {
    listStyleType: 'none',
    columns: 2,
    margin: 0,
    padding: 0,
    marginLeft: 20,
  },
  simpleList: {
    columns: 1,
    width: '100%',
    paddingTop: 34,
    paddingBottom: 24,
    margin: 0,
    [theme.breakpoints.down('xs')]: {
      marginTop: 0,
    },
    '& div': {
      paddingLeft: 15,
    },
    '& span': {
      ...theme.typography.body2,
      lineHeight: '33px',
    },
  },
  li: {
    padding: 0,
    '&:before': {
      content: '*',
    },
  },
}));

function TopicsList({ topics, selectTopic, isSearching }) {
  const classes = useStyles();
  const { clientDetails } = useSelector(clientDetailsSelector);
  const excludedTopics =
    _get(clientDetails, 'excludeTopicCollection.items') || [];
  const excludedSlugs = excludedTopics.map(({ slug }) => slug);
  return (
    <Grid item xs={isSearching ? 12 : 8}>
      <SimpleBar style={{ maxHeight: 300 }}>
        <Grid container>
          <List
            component="nav"
            aria-label="topics list"
            className={_Classnames(
              classes.ul,
              isSearching ? classes.simpleList : undefined,
            )}
          >
            {topics.map(({ title, slug, sys: { id }, reviewStatus }) => {
              // filter non accepted topic or excluded by clients
              if (reviewStatus !== 'Accepted' || excludedSlugs.includes(slug)) {
                return null;
              }

              const event = {
                target: {
                  value: title,
                },
              };
              return (
                // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
                <ListItem
                  button
                  className={classes.li}
                  onClick={() => selectTopic(slug, event, 'selectedTopic', id)}
                  key={id}
                >
                  <ListItemText className={classes.item}>{title}</ListItemText>
                </ListItem>
              );
            })}
            {_isEmpty(topics) && (
              <Typography variant="overline" className={classes.item}>
                No Matched Found.
              </Typography>
            )}
          </List>
        </Grid>
      </SimpleBar>
    </Grid>
  );
}

TopicsList.propTypes = {
  topics: PropTypes.array,
  selectTopic: PropTypes.func,
  isSearching: PropTypes.bool,
};

export default TopicsList;
